import type { SlotDesign } from './design-data';

// Mirror of photo-upload-backend/src/core/template/template.constants.ts.
// Keep the two lists in sync.

export const TEMPLATE_KINDS = ['greeting-card', 'invitation', 'menu'] as const;
export type TemplateKind = (typeof TEMPLATE_KINDS)[number];

export const TEMPLATE_CATEGORIES = [
  'birthday',
  'congrats',
  'thankyou',
  'love',
  'wedding',
  'baby',
  'getwell',
  'holiday',
  'sympathy',
  'faith',
  'family',
  'elegant',
  'modern',
  'fun',
  'cafe',
] as const;
export type TemplateCategory = (typeof TEMPLATE_CATEGORIES)[number];

export const CANONICAL_SLOT_KEYS = ['front', 'inside', 'back'] as const;

/** Slovenian labels for the admin UI (customer UI translates via next-intl). */
export const CATEGORY_LABELS_SL: Record<string, string> = {
  birthday: 'Rojstni dan',
  congrats: 'Čestitke',
  thankyou: 'Zahvala',
  love: 'Ljubezen',
  wedding: 'Poroka',
  baby: 'Dojenček',
  getwell: 'Hitro okrevanje',
  holiday: 'Prazniki',
  sympathy: 'Sožalje',
  faith: 'Krst in vera',
  family: 'Družina',
  elegant: 'Elegantno',
  modern: 'Moderno',
  fun: 'Zabavno',
  cafe: 'Kavarna',
};

/** Authoring floor: canonical pages per kind with default print specs (matches
 *  current prod formats). Real product definitions override these specs when
 *  they declare the same key. */
export const KIND_DEFAULT_SLOTS: Record<
  string,
  Array<{ key: string; printSpec: { widthMm: number; heightMm: number; bleedMm: number; safeMm?: number } }>
> = {
  'greeting-card': [
    { key: 'front', printSpec: { widthMm: 148, heightMm: 210, bleedMm: 0, safeMm: 5 } },
    { key: 'inside', printSpec: { widthMm: 148, heightMm: 210, bleedMm: 0, safeMm: 5 } },
    { key: 'back', printSpec: { widthMm: 148, heightMm: 210, bleedMm: 0, safeMm: 5 } },
  ],
  invitation: [
    { key: 'front', printSpec: { widthMm: 105, heightMm: 148, bleedMm: 3, safeMm: 5 } },
    { key: 'back', printSpec: { widthMm: 105, heightMm: 148, bleedMm: 3, safeMm: 5 } },
  ],
  menu: [
    { key: 'front', printSpec: { widthMm: 148, heightMm: 210, bleedMm: 3, safeMm: 5 } },
    { key: 'back', printSpec: { widthMm: 148, heightMm: 210, bleedMm: 3, safeMm: 5 } },
  ],
};

const LEGACY_SLOT_KEYS: Record<string, string> = { face: 'front' };

/** Map pre-migration slot keys in restored drafts to the canonical set.
 *  Returns new slot objects; never mutates the input. */
export function mapLegacySlotKeys(slots: SlotDesign[]): SlotDesign[] {
  return slots.map((s) =>
    LEGACY_SLOT_KEYS[s.slotKey] ? { ...s, slotKey: LEGACY_SLOT_KEYS[s.slotKey] } : s,
  );
}
